import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../../class/base-component.class';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { MessageType } from '../../enums/message-type.enum';

@Component({
  selector: 'app-response-download',
  templateUrl: './response-download.component.html',
  styleUrl: './response-download.component.scss'
})
export class ResponseDownloadComponent extends BaseComponent implements OnChanges {

  @Input() input: any | undefined;
  @Input() downloadFile = false;

  fileData: any = [];
  isExpired: boolean = false;
  loading: boolean = false;
  isDownloaded: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['input']?.currentValue) {
      this.fileData = this.formatInputFiles((this.input?.outputFiles || this.input?.output_files));
      this.isExpired = this.fileExpiryCalculation( this.input?.createdAt);
      setTimeout(() => {
        this.isExpired = true;
      }, 300000); //5 mins
    }
  }

  formatInputFiles(files:any[]){
    return files.map(file => ({...file, expired: false, loading: false}))
  }

  
  formatFileSize(sizeInBytes: number): string {
    if (!sizeInBytes) return 'Unknown Size';
    const sizeInKB = sizeInBytes / 1024;
    const sizeInMB = sizeInKB / 1024;
    return sizeInMB >= 1
      ? `${sizeInMB.toFixed(2)} MB`
      : `${sizeInKB.toFixed(2)} KB`;
  }

  fileExpiryCalculation(recordTime: string){
    const recordCreatedTime = new Date(recordTime).getTime();
    const currentTime = new Date().getTime();
    const expiryTime = 1 * 60 * 1000;
    if((currentTime - recordCreatedTime) > expiryTime) {
      return true;
    } else {
      return false;
    }
  }


  async onDownload(fileInfo: any, index: number) {
    try {
      this.fileData [index].loading = true;
      const file = await this.httpService.makeApiCall(`${environment.API_URL}matching/download-file`, {fileName: fileInfo.name}, { headers: { "access-name": "matching~download-file"}, responseType: 'blob'} as any , {method: 'post'} as any) as any;

      // Check if file data exists
      if (!file) {
        this.loading = false;
        this.notificationService.notify('No file data found to download', MessageType.Error)
        return;
      }

      const blob = new Blob([file], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');

      a.href = url;
      a.download = fileInfo.name;

      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      a.remove();

      setTimeout(() => {
        this.isDownloaded = true;
        this.loading = false;
      }, 2000);
      this.fileData[index].expired = true;
      this.notificationService.notify('File Downloaded Successfully', MessageType.Success)

    } catch (error) {
      this.loading = false
      this.isDownloaded = false;
      console.error('Error downloading file:', error);
      this.notificationService.notify(error as string, MessageType.Error)
    }finally{
      this.fileData[index].loading = false;
    }
  }
}
